import useToasts from '../../../hooks/use-toasts';
import { useMutation } from 'react-query';

export const useToastedMutation = ({
    mutationFn,
    successToast = 'Success!',
    onSuccessToast,
    errorToast = 'An error occurred.',
    onErrorToast,
    ...params
}) => {
    const { success, error } = useToasts();
    return useMutation(
        mutationFn,
        {
            onSuccess: (...args) => {
                const message = onSuccessToast ? onSuccessToast(...args) : successToast;
                success(message);
                params.onSuccess && params.onSuccess(...args);
            },
            onError: (...args) => {
                const message = onErrorToast ? onErrorToast(...args) : errorToast;
                error(message);
                params.onSuccess && params.onError(...args);
            }
        }
    );
};
